// Local assets store meant to keep icons till they appear in Cosmos
// if there are no intensions to keep them there, use icons as components' local resources

import LocalRectangle from './assets/local-rectangle.svg';

type AssetsStoreLocalProps = {
    'local-rectangle': typeof LocalRectangle;
};

const AssetsStoreLocal: AssetsStoreLocalProps = {
    'local-rectangle': LocalRectangle,
};

export default AssetsStoreLocal;
